/** rx: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "nothingSet": "nothing chosen yet",
  "simple": "Simple",
  "advanced": "Advanced rules",
  "mAlways": "Always play",
  "mAlwaysD": "No limits.",
  "mOnly": "Only play when…",
  "mOnlyD": "Plays only at the times, places and players you choose.",
  "mPause": "Pause when…",
  "mPauseD": "Plays as usual, except at the times, places and players you choose.",
  "allMustMatchPlay": "It plays when everything you set below matches. Leave a part empty to not limit by it.",
  "allMustMatchPause": "It pauses when everything you set below matches. Leave a part empty to not limit by it.",
  "secWhen": "When",
  "days": "Days",
  "betweenLabel": "Between",
  "allDay": "All day",
  "whenHint": "No days picked means every day; no hours means all day. An end before the start runs past midnight.",
  "secTags": "On players tagged",
  "secPlaces": "In these places",
  "secDates": "During",
  "anyDateOpt": "Any date",
  "betweenDates": "Between dates",
  "o_landscape": "landscape",
  "o_portrait": "portrait",
  "o_landscape_flipped": "landscape (flipped)",
  "o_portrait_flipped": "portrait (flipped)",
  "sep": ", ",
  "or": " or ",
  "and": " and ",
  "everyDay": "every day",
  "on": "on {v}",
  "notOn": "not on {v}",
  "between": "between {from}–{to}",
  "notBetween": "not between {from}–{to}",
  "fromDate": "from {d}",
  "untilDate": "until {d}",
  "anyDate": "any date",
  "outside": "outside {v}",
  "playerWith": "player with {match} {tags}",
  "playerWithout": "player without {match} {tags}",
  "allOf": "all of",
  "anyOf": "any of",
  "inGroup": "player in {v}",
  "notInGroup": "player not in {v}",
  "aGroup": "a group",
  "onlyOnPlayers": "only on {v}",
  "notOnPlayers": "not on {v}",
  "aPlayer": "a player",
  "inOrientation": "in {v} orientation",
  "notInOrientation": "not in {v} orientation",
  "insideRegion": "player inside {v}",
  "outsideRegion": "player outside {v}",
  "aRegion": "a region",
  "notGroup": "not ({v})",
  "none": "Always plays",
  "playsWhen": "Plays when {v}",
  "logicEmpty": "Logic (empty)",
  "tagsX": "tags: {v}",
  "inRegion": "in {v}",
  "playIf": "Only plays: {v}",
  "dontPlayIf": "Paused: {v}",
  "dontPlayIfShort": "Don't play if",
  "removeX": "Remove {v}",
  "is": "is",
  "and2": "and",
  "from2": "from",
  "removeCondN": "Remove condition {n}",
  "restrictedX": "Restricted “{name}” on all players",
  "unrestrictedX": "Removed the restriction on “{name}”",
  "onAll": "{name} · on all players",
  "appliesItem": "Applies everywhere this item plays: on every player, group and tag it is published to, and inside playlists. A player’s own restriction still applies too: it plays only when both allow it.",
  "appliesCampaign": "Applies everywhere this campaign plays: on every player, group and tag it is published to, and inside playlists. A player’s own restriction still applies too: it plays only when both allow it.",
  "appliesPlaylist": "Applies everywhere this playlist plays: on every player, group and tag it is published to. A player’s own restriction still applies too: it plays only when both allow it.",
  "editor": "Editor",
  "visual": "Visual",
  "logic": "Logic",
  "mode": "Mode",
  "noRestrictions": "No restrictions",
  "playIfShort": "Play if",
  "dateTime": "Date & Time",
  "from": "From",
  "to": "To",
  "clear": "Clear",
  "dtHint": "No days = every day. No times = all day. A To earlier than From runs past midnight.",
  "tags": "Tags",
  "addTagPh": "Type a tag, press Enter",
  "addTag": "Add a tag",
  "tagsHint": "Players need every tag listed here, their own or their group's.",
  "regions": "Regions",
  "noRegions": "No regions yet.",
  "regionsHint": "Players inside any of these, by the location set on them.",
  "manageRegions": "Edit places ↗",
  "startEnd": "Start & End Date",
  "alwaysActive": "Always active",
  "custom": "Custom",
  "start": "Start",
  "end": "End",
  "checkedHint": "Day, time and date are checked on the player at each moment, in its time zone, even offline. Player tags, groups, specific players, orientation and regions are decided when the change is published.",
  "vDays": "Day of the week",
  "vTime": "Time of day",
  "vDates": "Date",
  "vTags": "Player tags",
  "vGroups": "Player groups",
  "vPlayers": "Specific players",
  "vOrientation": "Player orientation",
  "vRegions": "Player region",
  "sunThu": "Sun–Thu",
  "friSat": "Fri–Sat",
  "everyDayCap": "Every day",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "landscapeF": "Landscape (flipped)",
  "portraitF": "Portrait (flipped)",
  "condGroup": "Condition group",
  "polarity": "Group polarity",
  "playWhen": "Play when",
  "where": "Where",
  "playUnless": "Play unless",
  "whereNot": "Where not",
  "combine": "Combine with",
  "allTrue": "all of these are true",
  "anyTrue": "any of these is true",
  "removeGroup": "Remove group",
  "condition": "Condition",
  "isOrNot": "Is or is not",
  "isNot": "is not",
  "checkedOffline": "Checked by the player itself, offline",
  "decidedPublish": "Decided when the change is published",
  "onPlayer": "on the player",
  "perPlayer": "per player",
  "between2": "between",
  "pastMidnight": "(an end before the start runs past midnight)",
  "until": "until",
  "startDate": "Start date (empty = no start)",
  "endDate": "End date (empty = no end)",
  "emptyOpen": "empty = open",
  "tagMatch": "Tag match",
  "anyTags": "any of these tags",
  "allTags": "all of these tags",
  "noGroups": "No player groups yet.",
  "insideAny": "Inside any of these.",
  "addCondition": "+ Condition",
  "addGroup": "+ Group",
  "invalid": "Invalid restriction",
  "restriction": "Restriction",
  "removeRestriction": "Remove restriction",
  "cancel": "Cancel",
  "apply": "Apply",
  "saving": "Saving…"
};
const ar: typeof en = {
  "nothingSet": "لم يُحدد شيء بعد",
  "simple": "بسيط",
  "advanced": "قواعد متقدمة",
  "mAlways": "التشغيل دائمًا",
  "mAlwaysD": "بلا قيود.",
  "mOnly": "التشغيل فقط عندما…",
  "mOnlyD": "يُعرض فقط في الأوقات والأماكن والمشغلات التي تختارها.",
  "mPause": "الإيقاف المؤقت عندما…",
  "mPauseD": "يُعرض كالمعتاد، إلا في الأوقات والأماكن والمشغلات التي تختارها.",
  "allMustMatchPlay": "يُعرض عندما يتطابق كل ما تحدده أدناه. اترك أي جزء فارغًا لعدم التقييد به.",
  "allMustMatchPause": "يتوقف مؤقتًا عندما يتطابق كل ما تحدده أدناه. اترك أي جزء فارغًا لعدم التقييد به.",
  "secWhen": "متى",
  "days": "الأيام",
  "betweenLabel": "بين",
  "allDay": "طوال اليوم",
  "whenHint": "عدم اختيار أيام يعني كل يوم، وعدم تحديد ساعات يعني طوال اليوم. نهاية قبل البداية تمتد بعد منتصف الليل.",
  "secTags": "على المشغلات الموسومة بـ",
  "secPlaces": "في هذه الأماكن",
  "secDates": "خلال",
  "anyDateOpt": "أي تاريخ",
  "betweenDates": "بين تاريخين",
  "o_landscape": "أفقي",
  "o_portrait": "عمودي",
  "o_landscape_flipped": "أفقي (مقلوب)",
  "o_portrait_flipped": "عمودي (مقلوب)",
  "sep": "، ",
  "or": " أو ",
  "and": " و",
  "everyDay": "كل يوم",
  "on": "في {v}",
  "notOn": "ليس في {v}",
  "between": "بين {from}–{to}",
  "notBetween": "ليس بين {from}–{to}",
  "fromDate": "من {d}",
  "untilDate": "حتى {d}",
  "anyDate": "أي تاريخ",
  "outside": "خارج {v}",
  "playerWith": "مشغل لديه {match} {tags}",
  "playerWithout": "مشغل ليس لديه {match} {tags}",
  "allOf": "كل",
  "anyOf": "أيٌّ من",
  "inGroup": "مشغل في {v}",
  "notInGroup": "مشغل ليس في {v}",
  "aGroup": "مجموعة",
  "onlyOnPlayers": "فقط على {v}",
  "notOnPlayers": "ليس على {v}",
  "aPlayer": "مشغل",
  "inOrientation": "بالاتجاه {v}",
  "notInOrientation": "ليس بالاتجاه {v}",
  "insideRegion": "مشغل داخل {v}",
  "outsideRegion": "مشغل خارج {v}",
  "aRegion": "منطقة",
  "notGroup": "ليس ({v})",
  "none": "يُعرض دائمًا",
  "playsWhen": "يُعرض عندما {v}",
  "logicEmpty": "منطق (فارغ)",
  "tagsX": "الوسوم: {v}",
  "inRegion": "في {v}",
  "playIf": "يُعرض فقط: {v}",
  "dontPlayIf": "متوقف مؤقتًا: {v}",
  "dontPlayIfShort": "لا يُعرض إذا",
  "removeX": "إزالة {v}",
  "is": "هو",
  "and2": "و",
  "from2": "من",
  "removeCondN": "إزالة الشرط {n}",
  "restrictedX": "تم تقييد «{name}» على كل المشغلات",
  "unrestrictedX": "تمت إزالة القيد عن «{name}»",
  "onAll": "{name} · على كل المشغلات",
  "appliesItem": "ينطبق أينما يُعرض هذا العنصر: على كل مشغل ومجموعة ووسم نُشر عليه، وداخل قوائم التشغيل. ويظل قيد المشغل نفسه ساريًا: لا يُعرض إلا عندما يسمح الاثنان.",
  "appliesCampaign": "ينطبق أينما تُعرض هذه الحملة: على كل مشغل ومجموعة ووسم نُشرت عليه، وداخل قوائم التشغيل. ويظل قيد المشغل نفسه ساريًا: لا تُعرض إلا عندما يسمح الاثنان.",
  "appliesPlaylist": "ينطبق أينما تُعرض قائمة التشغيل هذه: على كل مشغل ومجموعة ووسم نُشرت عليه. ويظل قيد المشغل نفسه ساريًا: لا تُعرض إلا عندما يسمح الاثنان.",
  "editor": "المحرر",
  "visual": "مرئي",
  "logic": "منطقي",
  "mode": "الوضع",
  "noRestrictions": "بلا قيود",
  "playIfShort": "يُعرض إذا",
  "dateTime": "التاريخ والوقت",
  "from": "من",
  "to": "إلى",
  "clear": "مسح",
  "dtHint": "بلا أيام = كل يوم. بلا أوقات = طوال اليوم. إذا كان «إلى» قبل «من» يمتد بعد منتصف الليل.",
  "tags": "الوسوم",
  "addTagPh": "+ إضافة وسم",
  "addTag": "إضافة وسم",
  "tagsHint": "يجب أن يحمل المشغل كل هذه الوسوم (وسومه أو وسوم مجموعته).",
  "regions": "المناطق",
  "noRegions": "لا توجد مناطق بعد.",
  "regionsHint": "يجب أن يكون المشغل داخل أيٍّ منها (حسب الموقع المضبوط له).",
  "manageRegions": "إدارة المناطق ↗",
  "startEnd": "تاريخ البداية والنهاية",
  "alwaysActive": "نشط دائمًا",
  "custom": "مخصص",
  "start": "البداية",
  "end": "النهاية",
  "checkedHint": "يُفحص اليوم والوقت والتاريخ على المشغل في كل لحظة، بمنطقته الزمنية، حتى دون اتصال. أما وسوم المشغل ومجموعاته والمشغلات المحددة والاتجاه والمناطق فتُحسم عند نشر التغيير.",
  "vDays": "يوم الأسبوع",
  "vTime": "وقت اليوم",
  "vDates": "التاريخ",
  "vTags": "وسوم المشغل",
  "vGroups": "مجموعات المشغل",
  "vPlayers": "مشغلات محددة",
  "vOrientation": "اتجاه المشغل",
  "vRegions": "منطقة المشغل",
  "sunThu": "الأحد–الخميس",
  "friSat": "الجمعة–السبت",
  "everyDayCap": "كل يوم",
  "landscape": "أفقي",
  "portrait": "عمودي",
  "landscapeF": "أفقي (مقلوب)",
  "portraitF": "عمودي (مقلوب)",
  "condGroup": "مجموعة شروط",
  "polarity": "نوع المجموعة",
  "playWhen": "يُعرض عندما",
  "where": "حيث",
  "playUnless": "يُعرض ما لم",
  "whereNot": "حيث لا",
  "combine": "الدمج بـ",
  "allTrue": "كل هذه صحيحة",
  "anyTrue": "أيٌّ من هذه صحيح",
  "removeGroup": "إزالة المجموعة",
  "condition": "الشرط",
  "isOrNot": "يساوي أو لا يساوي",
  "isNot": "ليس",
  "checkedOffline": "يفحصه المشغل نفسه دون اتصال",
  "decidedPublish": "يُحسم عند نشر التغيير",
  "onPlayer": "على المشغل",
  "perPlayer": "لكل مشغل",
  "between2": "بين",
  "pastMidnight": "(النهاية قبل البداية تمتد بعد منتصف الليل)",
  "until": "حتى",
  "startDate": "تاريخ البداية (فارغ = بلا بداية)",
  "endDate": "تاريخ النهاية (فارغ = بلا نهاية)",
  "emptyOpen": "فارغ = مفتوح",
  "tagMatch": "مطابقة الوسوم",
  "anyTags": "أيٌّ من هذه الوسوم",
  "allTags": "كل هذه الوسوم",
  "noGroups": "لا توجد مجموعات مشغلات بعد.",
  "insideAny": "داخل أيٍّ منها.",
  "addCondition": "+ شرط",
  "addGroup": "+ مجموعة",
  "invalid": "قيد غير صالح",
  "restriction": "القيد",
  "removeRestriction": "إزالة القيد",
  "cancel": "إلغاء",
  "apply": "تطبيق",
  "saving": "جارٍ الحفظ…"
};
export default { en, ar };
